import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.carousel = {}

        this.spaceBetweenValue = this.getData('space')
        this.breakpointValue = this.getData('breakpoint')
    
        // https://medium.com/@networkaaron/swiper-how-to-destroy-swiper-on-min-width-breakpoints-a947491ddec8
        this.breakpoint = window.matchMedia( `(min-width: ${this.breakpointValue ? this.breakpointValue : 700}px)` );
        
        this.breakpointChecker()

        this.bindEvents()
    }

    bindEvents() {
        this.breakpointCheckerBind = this.breakpointChecker.bind(this)
        this.breakpoint.addListener(this.breakpointCheckerBind);
    }

    unbindEvents() {
        this.breakpoint.removeListener(this.breakpointCheckerBind);
    }

    breakpointChecker() {
        if ( this.breakpoint.matches === true ) {
            this.carousel.destroy && this.carousel.destroy( true, true );
            return;
        } else if ( this.breakpoint.matches === false ) {

            window.requestAnimationFrame(() => {
                return this.enableSwiper();
            })
  
        }
    }

    enableSwiper() {
        this.carousel = new Swiper(this.el, {
            slidesPerView: 'auto',
            spaceBetween: this.spaceBetweenValue ? parseInt(this.spaceBetweenValue) : 0
        });
    }

    destroy() {
        super.destroy()
        this.unbindEvents();
        this.carousel.destroy && this.carousel.destroy(true,true)
    }
}
